import { Time } from '../../../types';
import { validateStoreHoursString } from '../validateStoreHoursString';

export const parseStoreHoursString = (storeHours: string): Time => {
	const invalidStoreHours = `Invalid storeHours "${storeHours}".`;

	const areStoreHoursValid = validateStoreHoursString(storeHours);

	if (!areStoreHoursValid) {
		throw new Error(invalidStoreHours);
	}

	switch (storeHours.length) {
		case 1:
		case 2:
			return {
				hours: 0,
				minutes: Number(storeHours)
			};
		case 3: {
			const hours = Number(storeHours.substr(0, 1));
			const minutes = Number(storeHours.substr(1));

			return {
				hours,
				minutes
			};
		}
		case 4: {
			const hours = Number(storeHours.substr(0, 2));
			const minutes = Number(storeHours.substr(2));

			return {
				hours,
				minutes
			};
		}
		/* istanbul ignore next */
		default:
			throw new Error(invalidStoreHours);
	}
};
